(function () {
  function qsa(root, sel) {
    return Array.prototype.slice.call(root.querySelectorAll(sel));
  }

  function findModal(root, id) {
    return root.querySelector('[data-m-team-modal][data-member-id="' + id + '"]');
  }

  function openModal(modal, opener) {
    if (!modal) return;
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    modal.dataset.openerId = opener ? opener.getAttribute('data-member-id') || '' : '';
    document.documentElement.classList.add('m-team--modal-open');
    var closeBtn = modal.querySelector('[data-m-team-close]');
    var closeReal = modal.querySelector('.m-team__modal-close');
    if (closeReal) closeReal.focus();
  }

  function closeModal(modal) {
    if (!modal) return;
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('m-team--modal-open');
  }

  document.querySelectorAll('[data-m-team]').forEach(function (root) {
    qsa(root, '[data-m-team-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-member-id') || '';
        openModal(findModal(root, id), btn);
      });
    });

    qsa(root, '[data-m-team-modal]').forEach(function (modal) {
      qsa(modal, '[data-m-team-close]').forEach(function (el) {
        el.addEventListener('click', function () {
          closeModal(modal);
        });
      });

      modal.addEventListener('click', function (e) {
        // click outside dialog closes
        var dialog = modal.querySelector('[role="dialog"]');
        if (!dialog) return;
        if (!dialog.contains(e.target) && e.target !== dialog) {
          closeModal(modal);
        }
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var open = document.querySelector('[data-m-team-modal]:not([hidden])');
      if (open) closeModal(open);
    });
  });
})();

